import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { MigrationMoneyPage, MIGRATION_FAQS } from "@/components/site/MigrationMoneyPage";
import { MexicoMarketSignal } from "@/components/site/MexicoMarketSignal";
import {
  buildHead,
  breadcrumbJsonLd,
  faqJsonLd,
  serviceJsonLd,
} from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/es/migracion-shopify";
const ALT = "/shopify-migration";
const TITLE = "Agencia de Migración a Shopify en México · Shugert";
const DESC =
  "Migración a Shopify para marcas en México: WooCommerce, Magento, BigCommerce, PrestaShop y plataformas custom con datos, SEO, integraciones, QA, cutover y estabilización.";

export const Route = createFileRoute("/es/migracion-shopify")({
  loader: async () => {
    await setEdgeHtmlCache();
  },
  head: () =>
    buildHead({
      locale: "es",
      title: TITLE,
      description: DESC,
      path: PATH,
      altPath: ALT,
      jsonLd: [
        breadcrumbJsonLd([
          { name: "Inicio", path: "/es" },
          { name: "Servicios", path: "/es/servicios" },
          { name: "Migración a Shopify en México", path: PATH },
        ]),
        faqJsonLd([...MIGRATION_FAQS.es]),
        serviceJsonLd({
          name: "Agencia de Migración a Shopify en México",
          description:
            "Migración end-to-end a Shopify o Shopify Plus para equipos en México y Latinoamérica desde WooCommerce, Magento, BigCommerce, PrestaShop, ecommerce custom y tiendas Shopify legacy.",
          path: PATH,
          serviceType: "Servicios de Migración a Shopify",
          minPrice: 5000,
          maxPrice: 75000,
          unit: "PROJECT",
          deliverables: [
            "Discovery de migración y arquitectura destino",
            "Decisiones de catálogo, clientes, contenido e historial de pedidos",
            "Mapeo de URLs, redirects y continuidad SEO técnica",
            "Implementación de theme o storefront",
            "Apps, integraciones, analítica y customer events",
            "QA, cutover y estabilización post-launch",
          ],
          locale: "es",
        }),
      ],
    }),
  component: () => (
    <SiteShell>
      <MigrationMoneyPage locale="es" />
      <MexicoMarketSignal
        title="Migraciones a Shopify para operaciones en México donde SEO, catálogo e integraciones no pueden tratarse como tareas separadas."
        body="Shugert migra tiendas de WooCommerce, Magento, BigCommerce, PrestaShop y plataformas custom a Shopify o Shopify Plus para equipos en México y Latinoamérica. El alcance cubre datos, redirects, continuidad SEO, storefront, integraciones, QA, cutover y estabilización post-launch."
        links={[
          { label: "Guías de migración", href: "/es/recursos/migracion" },
          { label: "Agencia Shopify Plus", href: "/es/agencia-shopify-plus" },
          { label: "SEO técnico Shopify", href: "/es/seo-tecnico-shopify" },
        ]}
      />
    </SiteShell>
  ),
});
